import { formatURL } from "../../common/utilities/format";
import { IAccount } from "../types/account";
import { graphResponse } from "./network";

const accountApi = "{{vroomOrigin}}/{{accountVersion}}/drive?expand=unifiedStorageQuota(expand=services)&prefer=isusqenlightened";

export function getAccount(fetch: (url: string, init?: RequestInit) => Promise<Response>, driveId: string): Promise<IAccount> {
  return graphResponse(fetch(formatURL(accountApi, { driveId })));
}

const unlockApi = "{{vroomOrigin}}/{{apiVersion1}}/drive/status/action.unlockDrive";

export function unlockAccount(fetch: (url: string, init?: RequestInit) => Promise<Response>): Promise<string | null> {
  return fetch(unlockApi, {
    headers: { "Content-Type": "application/json" },
    method: "POST"
  }).then((response) => {
    if (response.status === 202) {
      return Promise.resolve(response.headers.get("Location"));
    }

    return Promise.resolve(null);
  });
}
